import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CheckHtml5Service {

  constructor() { }
  public supports_video() {
    return !!document.createElement('video').canPlayType;
  }
  public supports_canvas() {
    return !!document.createElement('canvas').getContext;
  }

}
